import { createContext } from "react";

import type { RouteIsActiveContextType } from "./types";

export const RouteIsActiveContext = createContext<RouteIsActiveContextType>({ isActive: true });
